import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { StockConversionJobOrderModel } from "../../../../../../models";
import { BaseApiTemplateService, Core2Config } from "../../shared";

// https://api.akaun.cloud/core2/tnt/dm/erp/inventory-stock-conversion-job-order-links/backoffice-ep

@Injectable({ providedIn: "root" })
export class StockConversionJobOrderService extends BaseApiTemplateService<StockConversionJobOrderModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.ERP_PREFIX + "inventory-stock-conversion-job-order-links/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.ERP_PREFIX + "inventory-stock-conversion-job-order-links/backoffice-ep";
    this.httpClient = http;
  }
}
